import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';

import type { CediaIconProps } from './types';
import { faPowerShades } from './powershades-icon';

const CediaIcon = ({
	size = '1x',
	bottomColorOverride = '',
	topColorOverride = 'green',
	className = '',
}: CediaIconProps) => (
	<span className={`fa-stack ${className}`}>
		<FontAwesomeIcon
			icon={faFile}
			size={size}
			className={`fa-stack-2x ${bottomColorOverride && `text-${bottomColorOverride}`}`}
		/>
		<FontAwesomeIcon
			icon={faPowerShades}
			size={size}
			className={`fa-stack-1x stacked-logo text-${topColorOverride}`}
		/>
	</span>
);

export default CediaIcon;
